export enum FeatureToggle {
  CREATE_PO_PRODUCTS = 'create-po-products',
  CAN_USE_WORLDPAY = 'can-use-worldpay',
  CAN_VIEW_DIGITAL_SIGNAGE = 'can-view-digital-signage',
  CAN_USE_WEBSOCKET = 'websocket',
  PRODUCT_DETAILS_PACKAGE_DATE = 'product-details-package-date',
  ONLINE_ORDERING_MODULE = 'online-ordering-module',
  IRCC = 'IRCC',
  CAN_USE_OCS_COMPLIANCE = 'ocs-compliance',
  CAN_USE_CUSTOM_RECEIPT = 'can-use-custom-receipt',
  CAN_DISPLAY_LOYALTY_INFO_ON_RECEIPT = 'can-display-loyalty-info-on-receipt',
  CAN_USE_BULK_PRODUCT_UPDATE = 'can-use-bulk-product-update',
  CAN_USE_INSIGHTS_QUICKSIGHT = 'can-use-insights-quicksight',
  CAN_USE_LOYALTY_SERVICE = 'can-use-loyalty-service',
  CAN_USE_CUSTOMER_SEARCH_V2 = 'can-use-customer-search-v2',
  CAN_USE_PLATFORM_CUSTOMERS_SEARCH = 'can-use-platform-customers-search',
  CAN_USE_PLATFORM_CUSTOMERS_SEARCH_OUTREACH = 'can-use-platform-customers-search-outreach',
  CAN_USE_AUTO_LOYALTY_DISCOUNT = 'can-use-auto-loyalty-discount',
  CAN_VIEW_INVENTORY_SNAPSHOTS = 'can-view-inventory-snapshots',
  CAN_USE_GLOBAL_CATALOG = 'can-use-global-catalog',
  CAN_USE_OVERLAPPING_AUTO_DISCOUNTS = 'can-use-overlapping-auto-discounts',
  CAN_MANAGE_STACKING_DISCOUNTS = 'can-manage-stacking-discounts',
  CAN_BULK_CREATE_PRODUCTS = 'can-bulk-create-products',
  CAN_USE_TAX_CONFIG = 'can-use-tax-config',
  CAN_USE_SINGLE_BARCODE_VALIDATION = 'can-use-single-barcode-validation',
}
